$(document).ready(function($) {
  /*Rating working starts */
	/* Mouse over and mouse out on the stars */
    $(".js-rating-start").children('li').mouseover(function() {
        var ratingNumber = $(this).attr('data-rating');
        for (var r = 0; r <= ratingNumber; r++) {
            $(".article-rating-star").children('li[data-rating="' + r + '"]').addClass('active')
        }
    });
    $(".js-rating-start").children('li').mouseout(function() {
        $(".article-rating-star").children('li').removeClass('active');
    });

	/*Define variables*/
    var blogRating;
    var blogRatingValue;
	/* On click of star next to Rate this article - open Pop Up and set the values*/
    $(".article-rating-star").children('li').click(function() {

        $(".article-rating-star").children('li').removeClass('active-fix');
        var ratingNumber = $(this).attr('data-rating');
        blogRatingValue = $(this).attr('date-rating-value');

        blogRating = ratingNumber;
        for (var r = 0; r <= ratingNumber; r++) {
            $(".article-rating-star").children('li[data-rating="' + r + '"]').addClass('active-fix')
        }
        $(".rating-submit-section").show();
        $(".rating-thankyou").hide();
        $(".rating-value").html(blogRatingValue)
        $("#ratingPopup").show();
    })
    /*Close Modal pop up*/
    $(".js-model-close").click(function() {
        $("#ratingPopup").hide();
        $(".article-rating-star").children('li').removeClass('active-fix');
        blogRating = 0;
        blogRatingValue = "";
    })
    /* Click submit button */
    $(".js-submit-rating").click(function() {
        $(".rw-ui-star-" + blogRating).click();
        $(".rating-submit-section").hide();
        $(".rating-thankyou").show();
    })
    /*Rating working end */

    /* 
    Products page 
    - show only 2 pages in the pagination 
    */
	if (window.location.href.toLowerCase().indexOf('collections/new-products') > -1) {
        if (window.location.href.toLowerCase().indexOf('collections/new-products?page=2') > -1) {
            $(".shopify-pagination").addClass("collection-all-page2");
        } else {

            $(".shopify-pagination").addClass("collection-all-page1");
        }
    }

  /* Check if child element exists inside a UL */
if(  $('.js-check-child-elements ul li').length >= 1)
{
   $('.js-check-child-elements').show();
}
  else
  {
     $('.js-check-child-elements').hide();
  }

  
  /*Review Click */
   $(".product-grid-item .yotpo").parent('a').click(function(e) {
        e.preventDefault();
		  e.stopPropagation();
      var productUrl = $(this).attr("href");
     window.location.href = productUrl;
   })
   
    /*
    Blog Landing
    
     Tab Click*/
     /*block filter small screen click*/
  $('.tab-inner-section h5').click(function (e) {
    if($('.tab-inner-section ul').css("display")=="none")
    {
      $('.tab-inner-section ul').slideDown();
      $(this).addClass("active");
    }
    else
    { 
     $('.tab-inner-section ul').slideUp();
       $(this).removeClass("active");
    }
  })
  
    
   
  $('.js-tab-head-section li').click(function (e) {
    e.preventDefault();
    var id = jQuery(this).children('a').attr("href");
    if ($(id).css("display") == "none"); {
      $(".mobile-tab-title").html(jQuery(this).children('a').html())
      $('.tab-content-outer').children('.tab-content').hide();
      $('.js-tab-head-section li').removeClass("active");
      $(id).show();
      $(id).addClass("active");
      $(this).addClass("active");
       if ($(window).width() < 981) {
        $('.tab-inner-section ul').slideUp();
          $('.tab-inner-section h5').removeClass("active");
       }
    }
  })

  if (
    window.location.href.toLowerCase().indexOf("blogs/press-releases") > -1
  ) {     
      $("h1.page--title").text("Press Releases");
    } 

 else if(
    window.location.href.toLowerCase().indexOf("blogs/wellness") > -1
  ) {     
      $("h1.page--title").text("Natural Wellness Articles");
    }  

  else if(
    window.location.href.toLowerCase().indexOf("blogs/breaking-news") > -1
  ) {     
      $("h1.page--title").text("Breaking News");
    } 

   else if (
    window.location.href.toLowerCase().indexOf("blogs/control-how-you-age") > -1
  ) {     
      $("h1.page--title").text("Longevity Articles");
    } 
});
